module.exports = __webpack_public_path__ + "static/media/Weber–Fechner Law - alex-azabache-kxEvTRN0dSk-unsplash.ddc100e8.jpg";